import logger from "../../../../utils/logger";
/**
 * Generate default parameters for an API endpoint
 * @param {Object} endpoint - The endpoint object
 * @param {Object} currentUser - The current user
 * @returns {Object} Default parameters for the endpoint
 */
export const getQueryParams = (endpoint, currentUser) => {
  const params = {};

  // If no current user, use default value
  const userId = currentUser?.id || 1;

  // Handle PUT endpoints with special care to preserve user data
  if (endpoint.method === "PUT") {
    if (endpoint.fnName === "updateUserProfile") {
      return {
        userId: userId,
        data: {
          firstName: currentUser?.firstName || "Eboo",
          lastName: currentUser?.lastName || "Administrator",
          contacts: [
            {
              deviceTokens: [],
              isContactable: true,
              isPrimary: true,
              type: "mobile",
              value: "",
            },
            {
              deviceTokens: [],
              isContactable: true,
              isPrimary: false,
              type: "mobile",
              value: "",
            },
          ],
          avatar:
            currentUser?.avatar ||
            "https://storage.googleapis.com/spacia-16ab5.appspot.com/user-156-_1733934562509_3574bc69_f4a2_4f07_ada4_63d7788f18da.png",
        },
      };
    }

    if (endpoint.fnName === "updateListing") {
      return {
        listingId: 31699,
        payload: {
          additionalSpec: "STUDIO",
          description: "dndmdm",
          mediaId: 31698,
          amenities: ["HotWater", "Bar", "Spa"],
          details: {
            capacity: "1",
            floorNumber: "2",
            propertySize: "1",
            maxCapacity: "2",
            id: 31700,
          },
          listingType: "published",
          location: {
            address: "PR5R+R62, Nairobi, Kenya Muthurwa-south east commercial park",
            city: "Nairobi",
            country: "ke",
            latitude: -1.2902933090861608,
            longitude: 36.84068338119869,
            streetName: "",
            id: 31701,
          },
          propertyPrice: {
            billingPeriod: "HOURLY",
            price: "23",
            id: 31702,
          },
          propertyStatus: "FOR_RENT",
          propertyTitle: "ndnd",
          propertyType: "RESIDENTIAL_SPACE",
          tags: [
            { id: "djdjj", text: "djdjj", className: "" },
            { id: "dmdd", text: "dmdd", className: "" },
            { id: "s", text: "s", className: "" },
            { id: "dd", text: "dd", className: "" },
          ],
          typeOfWorkspace: "SERVICED_APARTMENTS",
          userId: 1646,
          zone: "ZONE_1",
        },
      };
    }

    if (endpoint.fnName === "publishListing") {
      return {
        id: 1,
        userId: userId,
      };
    }

    if (endpoint.fnName === "updateCompanyProfile") {
      const companyData = currentUser?.company || {};
      return {
        companyId: companyData.id || 1,
        payload: {
          id: 1,
          name: "Spacia Africa",
          address: "p.o box 1234 Nairobi",
          userId: userId,
          domain: "spacia.africa",
          contacts: [
            {
              contactType: "email",
              id: null,
              value: "faithmutheu78.fm+h2@gmail.com",
            },
            {
              contactType: "mobile",
              id: null,
              value: "+233707841187",
            },
          ],
          country: "ke",
          enabled: true,
          location: [
            {
              latitude: "0.00",
              longitude: "0.00",
              streetName: "NA",
            },
          ],
          spaceType: "low",
          type: "platformOwner",
          webUrl: "https://spaciaafrica.co.ke",
        },
        headers: {
          "Content-Type": "application/json",
        },
      };
    }

    if (endpoint.fnName === "updateAnnouncement") {
      return {
        id: 126,
        payload: {
          id: 126,
          title: "Team Invitation Update for Emmanuel",
          message: "Emmanuel has accepted your team invitation...",
          datetimeToSend: new Date().toISOString(),
        },
      };
    }
  }

  // Special case for getGroupMembers
  if (endpoint.fnName === "getGroupMembers") {
    return {
      groupId: 27945,
      page: 0,
      size: 10,
    };
  }

  // Special case for download invoice
  if (endpoint.fnName === "downloadInvoice") {
    return {
      userId: userId,
      token: "sample-invoice-token",
    };
  }

  // Special case for download statement
  if (endpoint.fnName === "downloadStatement") {
    // Default to last 30 days (past dates, not future)
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);

    // Format dates as DD/MM/YYYY for the backend API
    const formatDate = date => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const startAt = formatDate(startDate);
    const endAt = formatDate(endDate);

    logger.log(`Setting statement date range: ${startAt} to ${endAt} (DD/MM/YYYY format)`);

    return {
      userId: userId,
      customerId: userId,
      startAt: startAt,
      endAt: endAt,
    };
  }

  // Special case for checkInOrOut
  if (endpoint.fnName === "checkInOrOut") {
    return {
      bookingId: 1,
      userId: userId,
      username: currentUser?.username || "johndoe@example.com",
    };
  }

  // Special case for markNotificationAsRead
  if (endpoint.fnName === "markNotificationAsRead") {
    return {
      notificationId: "5642", // Use the exact notification ID from the example
      userId: "156", // Use the exact user ID from the example
      readStatus: true,
    };
  }

  // Special case for cancelBooking
  if (endpoint.fnName === "cancelBooking") {
    return {
      bookingId: 1234, // Use a real booking ID
      userId: userId,
    };
  }

  // Special case for updateGroupName
  if (endpoint.fnName === "updateGroupName") {
    return {
      groupId: 28018,
      name: "mdm", // Use the exact value that works
    };
  }

  // Special case for createGroup
  if (endpoint.fnName === "createGroup") {
    return {
      groupName: "mdmd",
      userIds: [],
    };
  }

  // Special case for addUsersToGroup
  if (endpoint.fnName === "addUsersToGroup") {
    return {
      groupId: 28018,
      addUsers: [895], // Format from working example
    };
  }

  // Special case for removeUsersFromGroup
  if (endpoint.fnName === "removeUsersFromGroup") {
    return {
      groupId: 28018,
      removeUsers: [123], // Format from working example
    };
  }

  // Otherwise, generate params from the param names
  endpoint.params.forEach(param => {
    if (
      param === "userId" ||
      param === "ownerId" ||
      param === "approverId" ||
      param === "inviterId" ||
      param === "hostId"
    ) {
      params[param] = userId;
    } else if (param === "page") {
      params[param] = 0;
    } else if (param === "size") {
      params[param] = 10;
    } else if (param === "id" || param === "bookingId" || param === "listingId" || param === "groupId") {
      params[param] = 1;
    } else if (param === "username") {
      params[param] = currentUser?.username || "johndoe@example.com";
    } else if (param === "active") {
      params[param] = true;
    } else if (param === "enable") {
      params[param] = true;
    } else if (param === "search" || param === "searchValue" || param === "declineReason") {
      params[param] = "";
    } else if (param === "startOn" || param === "startAt" || param === "start") {
      params[param] = new Date().toISOString();
    } else if (param === "endOn" || param === "endAt" || param === "end") {
      params[param] = new Date(Date.now() + 86400000).toISOString();
    } else if (param === "payload" || param === "data") {
      // When creating empty payload/data objects, maintain user context if available
      if (currentUser) {
        if (param === "data" && endpoint.fnName.includes("user")) {
          // For user-related data payloads
          params[param] = {
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            username: currentUser.username,
            // Add other properties as needed from current user
          };
        } else {
          params[param] = {};
        }
      } else {
        params[param] = {};
      }
    } else if (param === "name") {
      params[param] = "Test Name";
    } else if (param === "email") {
      params[param] = currentUser?.username || "test@example.com";
    } else if (param === "message" || param === "description") {
      params[param] = "Test description";
    } else if (param === "status") {
      params[param] = "ACTIVE";
    } else if (param === "sortBy") {
      params[param] = "createdAt";
    } else if (param === "phoneNumber") {
      params[param] = "+1234567890";
    } else if (param === "token" && endpoint.fnName === "downloadInvoice") {
      params[param] = "sample-invoice-token";
    } else {
      params[param] = param.includes("Id") ? 1 : ""; // Default to 1 for IDs, empty string for others
    }
  });

  return params;
};

/**
 * Get arguments for the API call
 * @param {Object} endpoint - The endpoint object
 * @param {Object} endpointParams - The endpoint parameters
 * @param {number} userId - The current user ID
 * @returns {Array} Arguments for the API call
 */
export const getApiCallArguments = (endpoint, endpointParams, userId) => {
  let args = [];

  // Handle special cases based on the function name
  switch (endpoint.fnName) {
    case "getUserProfile":
      // Make sure we're explicitly passing a user ID number
      args = [Number(userId)];
      break;
    case "updateUserProfile":
      // For user profile updates, ensure we're passing data in the exact format required by the API
      args = [
        String(endpointParams.userId || userId),
        {
          firstName: endpointParams.data?.firstName || "Eboo",
          lastName: endpointParams.data?.lastName || "Administrator",
          contacts: endpointParams.data?.contacts || [
            {
              deviceTokens: [],
              isContactable: true,
              isPrimary: true,
              type: "mobile",
              value: "",
            },
            {
              deviceTokens: [],
              isContactable: true,
              isPrimary: false,
              type: "mobile",
              value: "",
            },
          ],
          avatar:
            endpointParams.data?.avatar ||
            "https://storage.googleapis.com/spacia-16ab5.appspot.com/user-156-_1733934562509_3574bc69_f4a2_4f07_ada4_63d7788f18da.png",
        },
      ];
      break;
    case "updateListing":
      // For listing updates, use the exact format from the Spacia API
      args = [
        Number(endpointParams.listingId || 31699),
        {
          additionalSpec: endpointParams.payload?.additionalSpec || "STUDIO",
          description: endpointParams.payload?.description || "dndmdm",
          mediaId: Number(endpointParams.payload?.mediaId || 31698),
          amenities: Array.isArray(endpointParams.payload?.amenities)
            ? endpointParams.payload.amenities
            : ["HotWater", "Bar", "Spa"],
          details: {
            capacity: endpointParams.payload?.details?.capacity || "1",
            floorNumber: endpointParams.payload?.details?.floorNumber || "2",
            propertySize: endpointParams.payload?.details?.propertySize || "1",
            maxCapacity: endpointParams.payload?.details?.maxCapacity || "2",
            id: Number(endpointParams.payload?.details?.id || 31700),
          },
          listingType: endpointParams.payload?.listingType || "published",
          location: {
            address:
              endpointParams.payload?.location?.address ||
              "PR5R+R62, Nairobi, Kenya Muthurwa-south east commercial park",
            city: endpointParams.payload?.location?.city || "Nairobi",
            country: endpointParams.payload?.location?.country || "ke",
            latitude: endpointParams.payload?.location?.latitude || -1.2902933090861608,
            longitude: endpointParams.payload?.location?.longitude || 36.84068338119869,
            streetName: endpointParams.payload?.location?.streetName || "",
            id: Number(endpointParams.payload?.location?.id || 31701),
          },
          propertyPrice: {
            billingPeriod: endpointParams.payload?.propertyPrice?.billingPeriod || "HOURLY",
            price: endpointParams.payload?.propertyPrice?.price || "23",
            id: Number(endpointParams.payload?.propertyPrice?.id || 31702),
          },
          propertyStatus: endpointParams.payload?.propertyStatus || "FOR_RENT",
          propertyTitle: endpointParams.payload?.propertyTitle || "ndnd",
          propertyType: endpointParams.payload?.propertyType || "RESIDENTIAL_SPACE",
          tags: endpointParams.payload?.tags || [
            { id: "djdjj", text: "djdjj", className: "" },
            { id: "dmdd", text: "dmdd", className: "" },
            { id: "s", text: "s", className: "" },
            { id: "dd", text: "dd", className: "" },
          ],
          typeOfWorkspace: endpointParams.payload?.typeOfWorkspace || "SERVICED_APARTMENTS",
          userId: Number(endpointParams.payload?.userId || 1646),
          zone: endpointParams.payload?.zone || "ZONE_1",
        },
      ];
      break;
    case "publishListing":
      args = [Number(endpointParams.id), Number(userId)];
      break;
    case "updateCompanyProfile":
      // Use the exact format from the example for updating company details
      args = [
        endpointParams.companyId?.toString() || "1",
        {
          id: Number(endpointParams.payload?.id || 1),
          name: endpointParams.payload?.name || "Spacia Africa",
          address: endpointParams.payload?.address || "p.o box 1234 Nairobi",
          userId: Number(userId),
          domain: endpointParams.payload?.domain || "spacia.africa",
          contacts: endpointParams.payload?.contacts || [
            {
              contactType: "email",
              id: null,
              value: "faithmutheu78.fm+h2@gmail.com",
            },
            {
              contactType: "mobile",
              id: null,
              value: "+233707841187",
            },
          ],
          country: endpointParams.payload?.country || "ke",
          enabled: typeof endpointParams.payload?.enabled === "boolean" ? endpointParams.payload.enabled : true,
          location: endpointParams.payload?.location || [
            {
              latitude: "0.00",
              longitude: "0.00",
              streetName: "NA",
            },
          ],
          spaceType: endpointParams.payload?.spaceType || "low",
          type: endpointParams.payload?.type || "platformOwner",
          webUrl: endpointParams.payload?.webUrl || "https://spaciaafrica.co.ke",
        },
        endpointParams.headers || {
          "Content-Type": "application/json",
        },
      ];
      break;
    case "getGroupMembers":
      // Cast all params to numbers to prevent type issues
      args = [Number(endpointParams.groupId), Number(endpointParams.page || 0), Number(endpointParams.size || 10)];
      break;
    case "getUserBookings":
      args = [Number(userId), endpointParams.params];
      break;
    case "getAllListings":
    case "getBookings":
      args = [endpointParams.params];
      break;
    case "searchListings":
      args = [endpointParams.data, endpointParams.params];
      break;
    case "createListing":
      args = [
        {
          additionalSpec: "STUDIO",
          description: "Sample listing description",
          mediaId: 31698, // Should be created first via createListingMedia
          media: {
            mediaId: 31698,
            images: [
              {
                id: "photo_2025-03-07 07.51.37.jpeg",
                blob: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAA", // Base64 truncated for brevity
                file: {},
                height: 1,
                width: 1,
                src: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAA", // Base64 truncated for brevity
                title: "photo_2025-03-07 07.51.37.jpeg",
              },
            ],
            imageTitle: "ee",
            imageDescription: "eee",
            videoOption: {
              uploadFrom: "YOUTUBE",
              videoLink: "",
            },
          },
          amenities: ["HotWater", "Bar", "Spa"],
          details: {
            capacity: "1",
            floorNumber: "2",
            propertySize: "1",
            maxCapacity: "2",
          },
          listingType: "published",
          location: {
            address: "PR5R+R62, Nairobi, Kenya Muthurwa-south east commercial park",
            city: "Nairobi",
            country: "ke",
            latitude: -1.2902933090861608,
            longitude: 36.84068338119869,
            streetName: "",
          },
          propertyPrice: {
            billingPeriod: "HOURLY",
            price: "23",
          },
          propertyStatus: "FOR_RENT",
          propertyTitle: "New Listing",
          propertyType: "RESIDENTIAL_SPACE",
          tags: [
            { id: "sample", text: "sample", className: "" },
            { id: "new", text: "new", className: "" },
          ],
          typeOfWorkspace: "SERVICED_APARTMENTS",
          userId: Number(userId),
          zone: "ZONE_1",
        },
      ];
      break;
    case "searchUsers":
      // Make sure we're passing a valid searchTerm string
      args = [endpointParams.searchTerm || ""];
      break;
    case "createBooking":
      args = [
        {
          userId: Number(userId),
          listingId: Number(endpointParams.listingId || 1),
          startOn: endpointParams.startOn || new Date().toISOString(),
          endOn: endpointParams.endOn || new Date(Date.now() + 86400000).toISOString(),
        },
      ];
      break;
    case "createTeamBooking":
      args = [
        {
          userId: Number(userId),
          listingId: Number(endpointParams.listingId || 1),
          groupId: Number(endpointParams.groupId || 1),
          startOn: endpointParams.startOn || new Date().toISOString(),
          endOn: endpointParams.endOn || new Date(Date.now() + 86400000).toISOString(),
          purpose: "Team Planning Meeting",
          notes: "Please prepare meeting materials",
        },
      ];
      break;
    case "createCompanyBooking":
      args = [
        {
          userId: Number(userId),
          listingId: Number(endpointParams.listingId || 1),
          startOn: endpointParams.startOn || new Date().toISOString(),
          endOn: endpointParams.endOn || new Date(Date.now() + 86400000).toISOString(),
          purpose: "Company-wide Training",
          openToAll: true,
          maxAttendees: 50,
          notes: "All departments should attend",
        },
      ];
      break;
    case "createIndividualBooking":
      args = [
        {
          userId: Number(userId),
          listingId: Number(endpointParams.listingId || 1),
          startOn: endpointParams.startOn || new Date().toISOString(),
          endOn: endpointParams.endOn || new Date(Date.now() + 86400000).toISOString(),
          purpose: "Personal Work Session",
          notes: "Do not disturb",
        },
      ];
      break;
    case "checkInOrOut":
      args = [Number(endpointParams.bookingId || 1), Number(userId), endpointParams.username || "johndoe@example.com"];
      break;
    case "downloadInvoice":
      args = [Number(userId), endpointParams.token || "invoice-token"];
      break;
    case "downloadStatement":
      args = [
        Number(userId),
        endpointParams.startAt || new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
        endpointParams.endAt || new Date().toISOString().split("T")[0],
      ];
      break;
    case "createAnnouncement":
      args = [
        {
          title: "System Maintenance",
          content: "The system will be undergoing scheduled maintenance on Friday from 11 PM to 1 AM GMT.",
          startDate: new Date().toISOString(),
          endDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days from now
          targetAudience: "ALL",
          priority: "MEDIUM",
          isActive: true,
        },
      ];
      break;
    case "updateAnnouncement":
      // Use the exact format from the Spacia API example
      args = [
        Number(endpointParams.id || 126),
        {
          id: Number(endpointParams.payload?.id || 126),
          title: endpointParams.payload?.title || "Team Invitation Update for Emmanuel",
          message: endpointParams.payload?.message || "Emmanuel has accepted your team invitation...",
          datetimeToSend: endpointParams.payload?.datetimeToSend || new Date().toISOString(),
        },
      ];
      break;
    case "inviteUsers":
      args = [
        {
          emails: ["user1@example.com", "user2@example.com"],
          message: "Please join our platform",
          role: "MEMBER",
          ownerId: Number(userId),
        },
      ];
      break;
    case "bulkInviteUsers":
      args = [
        {
          file: null, // This would be a File object in actual use
          ownerId: Number(userId),
        },
      ];
      break;
    case "assignBundle":
      args = [
        {
          userId: Number(userId),
          bundleId: 1,
          action: "ASSIGN", // or "REMOVE"
          quantity: 10,
        },
      ];
      break;
    case "createBundlePurchaseOrder":
      args = [
        {
          bundleId: 1,
          ownerId: Number(userId),
          quantity: 5,
          paymentMethod: "MOBILE_MONEY",
        },
      ];
      break;
    case "submitEnquiry":
      args = [
        {
          name: "John Doe",
          email: "john.doe@example.com",
          phoneNumber: "+233123456789",
          subject: "Inquiry about services",
          message: "I would like to learn more about your corporate packages.",
          companyName: "Example Corp",
          requestCallback: true,
        },
      ];
      break;
    case "reportIssue":
      args = [
        {
          userId: Number(userId),
          title: "Problem with booking",
          description: "I'm unable to complete my booking due to a payment processing error.",
          category: "PAYMENT",
          priority: "HIGH",
          attachments: [],
        },
      ];
      break;
    case "processPayment":
      args = [
        {
          userId: Number(userId),
          amount: 1000,
          currency: "GHS",
          paymentMethod: "MOBILE_MONEY",
          provider: "MTN",
          phoneNumber: "+233123456789",
          description: "Payment for booking #12345",
        },
        Number(userId),
      ];
      break;
    case "subscribeToNewsletter":
      args = [{ email: "subscriber@example.com" }];
      break;
    case "createGroup":
      args = [
        {
          groupName: endpointParams.groupName || "mdmd",
          userIds: endpointParams.userIds || [],
        },
      ];
      break;
    case "addUsersToGroup":
      args = [
        Number(endpointParams.groupId || 28018),
        {
          addUsers: Array.isArray(endpointParams.addUsers) ? endpointParams.addUsers : [895],
        },
      ];
      break;
    case "removeUsersFromGroup":
      args = [
        Number(endpointParams.groupId || 28018),
        {
          removeUsers: Array.isArray(endpointParams.removeUsers) ? endpointParams.removeUsers : [123],
        },
      ];
      break;
    case "updateGroupName":
      args = [Number(endpointParams.groupId || 28018), { name: endpointParams.name || "mdm" }];
      break;
    case "deleteGroup":
      args = [Number(endpointParams.groupId || 1)];
      break;
    case "createListingMedia":
      // Format for creating media before creating a listing
      args = [
        {
          title: endpointParams.title || "ee",
          description: endpointParams.description || "eee",
          images: [
            {
              id: "photo_2025-03-07 07.51.37.jpeg",
              blob: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAA", // Base64 truncated for brevity
              file: {},
              height: 1,
              width: 1,
              src: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAA", // Base64 truncated for brevity
              title: "photo_2025-03-07 07.51.37.jpeg",
            },
          ],
          videoOption: {
            uploadFrom: endpointParams.uploadFrom || "YOUTUBE",
            videoLink: endpointParams.videoLink || "",
          },
        },
        Number(endpointParams.userId || userId),
      ];
      break;
    case "markNotificationAsRead":
      // For marking a notification as read, use exact format from the working example
      args = [
        endpointParams.notificationId || "5642", // notification ID as string
        endpointParams.userId || "156", // user ID as string (not converting to Number)
        endpointParams.readStatus !== undefined ? endpointParams.readStatus : true,
      ];
      break;
    case "cancelBooking":
      // For cancelBooking, we need to pass both bookingId and userId as parameters
      args = [
        Number(endpointParams.bookingId || 1234), // Booking ID must be a valid number
        Number(userId),
      ];
      break;
    default:
      // Generic case - map params array to values from endpointParams
      args = endpoint.params.map(param => {
        // Replace any userId, ownerId parameters with the actual user ID
        if (
          param === "userId" ||
          param === "ownerId" ||
          param === "approverId" ||
          param === "inviterId" ||
          param === "hostId"
        ) {
          return userId;
        }
        return endpointParams[param];
      });
  }

  return args;
};
